import dayjs from 'dayjs'
import React, { useEffect, useState } from 'react'
import { hasPermission } from '../../config-func'
import { PAGE_SIZE_OPTIONS } from '../../configData'
import { departmentSearch, getSystemManager } from '../../services/cmsservice'
import Card from '../Card'
import ModalConfirm from '../common/ModalConfirm/ModalConfirm'
import TableField from '../common/Table/TableField'
import AuthenticatedLink from '../Export/AuthenticatedLink'
import FilterForm from './FilterForm'
import openNotification from '../common/Notification/openNotification '
import { debounce } from 'lodash'
import Loading from '../Loading';
const SystemManagement = () => {
  const permissions = JSON.parse(localStorage.getItem('permissions') || '[]')
  const [dataSource, setDataSource] = useState([])
  const [loading, setLoading] = useState(false)
  const [url, setUrl] = useState('')
  const [listDepartment, setListDepartment] = useState([])
  const defaultRange = [dayjs().subtract(30, 'day'), dayjs()] // default là 30 ngày gần nhất và max khoảng thời gian là ngày hiện tại và khoảng thời gian tối đa là 60 ngày

  const [filters, setFilters] = useState({
    currentPage: 1,
    pageSize: 10,
    date: defaultRange
  })

  const getDepartmentAll = async () => {
    const name = ''
    const type = ''
    const body = { name, type, pageSize: 1000 }
    try {
      const res = await departmentSearch(body)
      setListDepartment(res.data)
    } catch (err) {
      console.log('err', err)
    }
  }
  const handleSearch = debounce(() => {
    if (filters.currentPage === 1) {
      fetchData()
    } else {
      setFilters((prev) => ({ ...prev, currentPage: 1 }))
    }
  }, 1000)

  useEffect(() => {
    getDepartmentAll()
  }, [])

  async function fetchData(values = {}) {
    setLoading(true)

    let _dataSource = []
    // let _total = 0
    const fromDate =
      (filters?.date &&
        dayjs(filters?.date[0]).startOf('day').valueOf()) ||
      ''
    const toDate =
      (filters?.date &&
        dayjs(filters?.date[1]).hour(23).minute(59).second(59).valueOf()) ||
      ''
    const params = {
      page: filters.currentPage,
      pageSize: filters.pageSize,
      text_search: filters.text_search || '',
      department_id: values.department_id || filters.department_id || '',
      start_date: Math.floor(fromDate / 1000),
      end_date: Math.floor(toDate / 1000)
    }

    const cleanedData = Object.fromEntries(
      Object.entries(params).filter(
        ([_, value]) => value !== '' && value !== null && value !== undefined
      )
    )

    try {
      const response = await getSystemManager(cleanedData)
      // if (response?.code === 0) {
      // _total = response?.data?.total
      _dataSource = response?.data
      // }
    } catch (error) {
      openNotification(
        'error',
        error?.response?.data?.message || 'Đã có lỗi xảy ra'
      )
    } finally {
      setLoading(false)
      // setTotal(_total)
      setDataSource(_dataSource)
    }
  }

  useEffect(() => {
    if (!filters?.date || filters?.date?.length < 2) {
      return
    }
    if (localStorage.getItem('user_role') == 'ADMIN') {
      fetchData()
    } else {
      fetchData({
        department_id: localStorage.getItem('department_id')
      })
    }
  }, [filters.currentPage, filters.pageSize, filters.reset, filters.date])
  // -=0-=0-====================================================================================================
  // Columns for Table
  const initialColumns = [
    {
      title: 'STT',
      dataIndex: 'stt',
      key: 'stt',
      fixed: 'left',
      width: 60,
      align: 'center',
      render: (_, __, index) =>
        (filters.currentPage - 1) * filters.pageSize + index + 1
    },

    {
      title: 'Họ tên',
      dataIndex: 'name',
      key: 'name',
      width: 150,
      render: (_, record) => {
        return (
          <div
            style={{
              maxWidth: 400,
              whiteSpace: 'normal',
              wordWrap: 'break-word',
              overflowWrap: 'break-word'
            }}
          >
            {record.name}
          </div>
        )
      }
    },
    {
      title: 'ID',
      dataIndex: 'id',
      key: 'id',
      width: 80
      // render: (_, record) => {
      //   return <div>{record.user_info.name}</div>
      // }
    },
    {
      title: 'Sàn',
      dataIndex: 'department_name',
      key: 'department_name',
      width: 150
      // render: (_, record) => {
      //   return <div>{record.project_recommend_info.name}</div>
      // }
    },
    // { title: 'Quản lý TP', dataIndex: 'name', key: 'name' },
    {
      title: 'Đăng tin',
      dataIndex: 'create_post',
      key: 'create_post',
      width: 100
    },
    {
      title: 'Gửi yêu cầu',
      dataIndex: 'create_request',
      key: 'create_request',
      width: 150
    },
    {
      title: 'Xem tin',
      dataIndex: 'view',
      key: 'view',
      width: 120
    },
    {
      title: 'Sửa tin',
      dataIndex: 'edit',
      key: 'edit',
      width: 100
    },
    {
      title: 'Gọi điện',
      dataIndex: 'call',
      key: 'call',
      width: 120
    },
    {
      title: 'Note tin',
      dataIndex: 'note',
      key: 'note',
      width: 120
    },
    {
      title: 'Copy',
      dataIndex: 'copy',
      key: 'copy',
      width: 80
    },
    {
      title: 'Book',
      dataIndex: 'book',
      key: 'book',
      width: 80
    },
    {
      title: 'Phân quyền',
      dataIndex: 'assign',
      key: 'assign',
      width: 120
    },
    {
      title: 'Yêu thích tin',
      dataIndex: 'favourite',
      key: 'favourite',
      width: 120
    },
    {
      title: 'Nhận phân quyền',
      dataIndex: 'receive',
      key: 'receive',
      width: 150
    },
    {
      title: 'Cập nhật Hiện trạng',
      dataIndex: 'update_status',
      key: 'update_status',
      width: 180
    },
    {
      title: 'Báo cáo bài viết',
      dataIndex: 'report_community',
      key: 'report_community',
      width: 180
    },
    {
      title: 'Ẩn bài viết',
      dataIndex: 'hide_community',
      key: 'hide_community',
      width: 180
    },
    {
      title: 'Xoá tin',
      dataIndex: 'delete_community',
      key: 'delete_community',
      width: 120
    }
  ]

  const [isDisabled, setIsDisabled] = useState(false)
  useEffect(() => {
    const fromDate =
      (filters?.date &&
        dayjs(filters?.date[0]).startOf('day').valueOf()) ||
      ''
    const toDate =
      (filters?.date &&
        dayjs(filters?.date[1]).hour(23).minute(59).second(59).valueOf()) ||
      ''

    const p = {
      page: filters.currentPage,
      pageSize: filters.pageSize,
      text_search: filters.text_search || '',
      department_id: filters.department_id || '',
      start_date: Math.floor(fromDate / 1000),
      end_date: Math.floor(toDate / 1000)
    }
    const cleanedData = Object.fromEntries(
      Object.entries(p).filter(
        ([_, value]) => value !== '' && value !== null && value !== undefined
      )
    )
    const params = new URLSearchParams({ ...cleanedData })

    if (p.department_id == '') {
      setIsDisabled(true)
      // openNotification("error", 'Vui lòng chọn sàn')
    } else {
      setIsDisabled(false)
      setUrl(
        `${process.env.REACT_APP_API_URL}/api/v1/report/export-file?` +
          params
      )
    }
  }, [filters])

  return (
    <div>
      <Loading loading={loading} />
      <Card className="mb-2">
        <div
          style={{
            display: 'flex',
            justifyContent: 'flex-end',
            alignItems: 'center',
            margin: '0px 50px 10px 0px',
            width: '100%'
          }}
        ></div>

        <FilterForm
          handleSearch={handleSearch}
          setFilters={setFilters}
          fetchData={fetchData}
          listDepartment={listDepartment}
          setIsDisabled={setIsDisabled}
          defaultRange={defaultRange}
        />
      </Card>

      <Card>
        <div
          style={{
            display: 'flex',
            justifyContent: 'flex-end',
            alignItems: 'center',
            margin: '0px 50px 10px 0px',
            width: '100%'
          }}
        >
          {hasPermission('P36.1', permissions) && (
            <AuthenticatedLink
              url={url || ''}
              filename={'Danh-sach-quan-ly-van-hanh-he-thong'}
              disabled={isDisabled}
              type={1}
            >
              Export
            </AuthenticatedLink>
          )}
        </div>
        <TableField
          loading={loading}
          columns={initialColumns}
          dataSource={dataSource?.list}
          scroll={{
            x: dataSource?.list?.length > 0 ? 'max-content' : '100%',
            y: 'calc(100vh - 400px)'
          }}
          className={`custom-table`}
          pagination={{
            current: filters.currentPage,
            pageSize: filters.pageSize,
            total: dataSource?.total,
            pageSizeOptions: PAGE_SIZE_OPTIONS,
            showSizeChanger: true,
            onShowSizeChange: (current, size) => {
              setFilters((prev) => ({
                ...prev,
                pageSize: size,
                currentPage: 1
              }))
            },
            onChange: (page) => {
              setFilters((prev) => ({ ...prev, currentPage: page }))
            },
            locale: { items_per_page: 'bản ghi / trang' },
            showTotal: (total, range) =>
              `Hiển thị ${range[0]}-${range[1]} của ${total} bản ghi`
          }}
          rowKey={(record, index) => index}
          locale={{ emptyText: 'Không có dữ liệu' }}
        />
      </Card>
      <ModalConfirm />
    </div>
  )
}

export default SystemManagement
